module.exports = __webpack_public_path__ + "img/ManorFarm.9544cb09.jpg";